import{getMainDefinition as t}from"@apollo/client/utilities";function e({query:n}){const i=t(n);return i.kind==="OperationDefinition"?i.operation==="subscription":!1}export{e as isWebSocketSubscription};
//# sourceMappingURL=apollo.es.js.map
